<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">
        <span>{{year}} &copy; Culligan |&nbsp;</span>
        @if (commit !== undefined) {
          <span>Commit hash: {{commit}} |&nbsp;</span>
        }
        @if (version !== undefined) {
          <span>Version: {{version}}</span>
        }
      </div>
      <div class="col-sm-6">
        <div class="text-sm-end d-none d-sm-block">
          Designed & Developed by the ADT
        </div>
      </div>
    </div>
  </div>
</footer>
